import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import './deposit-momo-form.scss'
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";
import { makeMomoDepositTransaction } from '../../../services/transaction-service';
import { BsInfoCircleFill } from 'react-icons/bs';

const orderSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 digits')
    .max(5, "PIN must be exactly 5 digits")
    .matches(
      /^([0-9]){5}/,
      'PIN should be numeric.'
    ),
    momoDepositNumber: Yup.string()
    .required('Ce champs est obligatoire'),
});

const DepositMomoForm = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    // console.log(`Submitting the following data ${JSON.stringify(values)}`);
    makeMomoDepositTransaction(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        toast(`${res.message}. You can close this page and return to the app`);
        setMessage(`${res.message}. You can close this page and return to the app`);
      }else {
        toast(`Sorry! ${res.message}`);
        setErrorMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  return  (
    <div className="login-form">
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      <div className='login-info'><h2>AFTA WALLET</h2></div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          momoDepositNumber: "",
          momoDepositName: "",
          paymentMode: 'ussd',
          reference: "",
          id: userId,
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={orderSchema}
        >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            
            <div className={`field`}>
              <p>Complete wallet deposit.</p>
            </div>
            <div className={`field`}>
              <label htmlFor="momoDepositNumber">Number (Numéro)* 
                <BsInfoCircleFill title='The momo number used to make the transaction. Le numéro momo avec le quel effectuer la transaction'/>
              </label>
              <input
                name="momoDepositNumber"
                id="momoDepositNumber"
                placeholder="Include country code (ex. 2376xxxxxx)"
                value={values.momoDepositNumber}
                onChange={handleChange} />
              {errors.momoDepositNumber && touched.momoDepositNumber ? (
                <div className="error">{errors.momoDepositNumber}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="momoDepositName">Name (Nom)</label>
              <input
                name="momoDepositName"
                id="momoDepositName"
                placeholder="Full name"
                value={values.momoDepositName}
                onChange={handleChange} />
              {errors.momoDepositName && touched.momoDepositName ? (
                <div className="error">{errors.momoDepositName}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="reference">Reference 
                <BsInfoCircleFill title='If you received payment SMS, use the txn reference id. Si vous avez recu un SMS de paiement, veuiller entrer la reference de la transaction'/>
              </label>
              <input
                name="reference"
                id="reference"
                placeholder="Reference ID from SMS if applicable"
                value={values.reference}
                onChange={handleChange} />
              {errors.reference && touched.reference ? (
                <div className="error">{errors.reference}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="pin">PIN code<sup>*</sup></label>
              <input
                type='password'
                name="pin"
                id="pin"
                placeholder="Votre code PIN"
                value={values.pin}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>CONFIRMER</span>}
              {/* {isLoading && <span>Sending ...</span>} */}
              <BeatLoader
                color={Constant.spinner_color}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '5px'
                }}
              />
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted && 
        <p className='login-info'>
          {message}
        </p>
      }
    </div>
  );
};

export default DepositMomoForm;
